const ProfileLink = ({ title, url }) => {
  return (
    <a href={url} rel="norefferer" target="_blank">
      <div className="w-full rounded-button bg-black py-4 duration-default hover:bg-dark">
        <div className="mx-auto w-fit text-center text-white">{title}</div>
      </div>
    </a>
  );
};

export default ProfileLink;
